/** Matches statistics-style win rate: wins ÷ (wins + losses); breakeven excluded. Sample still counts scratch. */
export const WIN_RATE_COLUMN_TOOLTIP =
  "Win % is wins ÷ (wins + losses), same as statistics; breakeven (0 PnL) trades are not in the denominator. Sample size counts every trade in the row, including scratch.";

export const SLICE_CONFIGURATOR_TOOLTIP =
  "Pick regime, market direction, trade side, and/or session. Then choose an action: Open this slice jumps to the one combination that matches your selects exactly. Show matching slices keeps the All-trades tables open and only shows rows that include those dimensions (including combination rows).";

export const SHOW_MATCHING_SLICES_TOOLTIP =
  "Keeps exploring from All trades. Narrows drill-down tables to rows that include your selected dimensions, including combination slices.";

export const OPEN_THIS_SLICE_TOOLTIP =
  "Jumps to the single computed segment that matches your selects exactly, and scopes metrics/drilldowns to that slice.";

export const OPEN_SLICE_ROW_TOOLTIP =
  "Open this exact slice — hides the exploration table and shows metrics, buckets, and situations for that segment.";

export const OPEN_SLICE_COLUMN_HEADER_TOOLTIP =
  "Opens the row as an exact slice view (same as Open this slice in the configurator).";

export const DRILLDOWN_OPEN_ROW_TOOLTIP =
  "Open the matching computed slice from this row (loads the configurator and scopes drilldowns to that segment).";

export const DRILLDOWN_COLUMN_HEADER_TOOLTIP =
  "Loads the row into the slice configurator and opens the matching combined slice.";
